<script setup lang="ts">
import { computed } from "vue";

type PulseColor = "blue" | "red" | "orange" | "green" | "yellow";
type PulseSize = "small" | "normal" | "large";

type Props = {
  color?: PulseColor;
  size?: PulseSize;
};

const { color = "blue", size = "normal" } = defineProps<Props>();

const colorClass = computed(() => {
  switch (color) {
    case "red":
      return "bg-kekkle-red";
    case "orange":
      return "bg-orange";
    case "green":
      return "bg-green-500";
    case "yellow":
      return "bg-kekkle-yellow";
    case "blue":
    default:
      return "bg-kekkle-blue";
  }
});

const sizeClass = computed(() => {
  switch (size) {
    case "small":
      return "h-2 w-2";
    case "large":
      return "h-3.5 w-3.5";
    case "normal":
    default:
      return "h-2.5 w-2.5";
  }
});
</script>

<template>
  <span class="relative flex flex-shrink-0" :class="sizeClass">
    <span
      class="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75"
      :class="colorClass"
    ></span>
    <span
      class="relative inline-flex h-full w-full rounded-full"
      :class="colorClass"
    ></span>
  </span>
</template>
